import React from 'react';

const REASONS = [
  'Easy participation',
  'Transparent reward system',
  'Community-driven ecosystem',
  'Long-term blockchain vision',
  'Future XT Blockchain integration',
];

export default function WhyChoose() {
  return (
    <section id="why" className="section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <div className="section-eyebrow">WHY CHOOSE US</div>
          <h2 className="section-title">
            Why <span className="text-gradient">X-Terra Mining?</span>
          </h2>
        </div>
        <div className="why-grid">
          {REASONS.map((r, i) => (
            <div key={i} className="why-item">
              <div className="check">✓</div>
              <div>{r}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
